export class W3HeaderNavigation {
  burgerButton: HTMLElement | null;
  languageButtons: NodeListOf<Element> | null;
  languageDropdowns: NodeListOf<Element> | null;
  navigation: HTMLElement | null;
  mobileAccordionButtons: NodeListOf<Element> | null;

  constructor() {
    this.burgerButton = document.querySelector(".burger-button");
    this.languageButtons = document.querySelectorAll(
      ".language-switch--button",
    );
    this.languageDropdowns = document.querySelectorAll(
      ".language-switch--dropdown",
    );
    this.navigation = document.querySelector("#navigation");
    this.mobileAccordionButtons = document.querySelectorAll(
      "#header .menu-accordion-button",
    );
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.registerEventHandlers();
    this.openCurrentAccordion();
  }

  /**
   * registerEventHandlers - Register event handlers for the navigation component
   * @returns {void}
   */
  private registerEventHandlers(): void {
    if (!this.burgerButton) return;

    this.burgerButton.addEventListener("click", () => {
      let menuIsActive = this.burgerButton?.classList.contains("active");

      this.burgerButton?.classList.toggle("active", !menuIsActive);
      this.navigation?.classList.toggle("active", !menuIsActive);
      menuIsActive = this.burgerButton?.classList.contains("active");
      document.body.style.overflow = menuIsActive ? "" : "hidden";

      // Setup or remove the document-wide click listener based on the menu state
      if (menuIsActive) {
        document.addEventListener("click", this.handleOutsideClick);
      }
    });
    if (!this.mobileAccordionButtons) return;
    this.mobileAccordionButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const currentButton = event.target as HTMLElement;
        const isActive = currentButton.classList.contains("active");

        this.closeAllAccordions();

        if (!isActive) {
          currentButton.classList.add("active");

          const panel = currentButton.nextElementSibling;
          if (panel) {
            panel.classList.add("active");
          }
        }
      });
    });
    if (!this.languageButtons) return;
    if (!this.languageDropdowns) return;
    this.languageButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");

        this.languageDropdowns?.forEach((dropdown, dropdownIndex) => {
          dropdown.classList.toggle("active");
        });
      });
    });
  }

  /**
   * closeAllAccordions - Close all accordion panels by removing the active class
   * @returns {void}
   */
  private closeAllAccordions(): void {
    this.mobileAccordionButtons?.forEach((button) => {
      button.classList.remove("active");
      const panel = button.nextElementSibling;
      if (panel && panel.classList.contains("active")) {
        panel.classList.remove("active");
      }
    });
  }

  /**
   * handleOutsideClick - Handle clicks outside the navigation and burger button
   * @param {MouseEvent} event - The click event
   */
  private handleOutsideClick(event: MouseEvent): void {
    if (
      this.navigation &&
      !this.navigation.contains(event.target as Node) &&
      this.burgerButton &&
      !this.burgerButton.contains(event.target as Node)
    ) {
      this.burgerButton.classList.remove("active");
      this.navigation?.classList.remove("active");
      document.body.style.overflow = ""; // Allow scrolling again
      // Remove the listener since the menu is being closed
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }

  /**
   * openCurrentAccordion - Open the accordion panel for the current page
   * @returns {void}
   */
  private openCurrentAccordion(): void {
    const currentPageItem = document.querySelector(".current_page_item");

    if (currentPageItem) {
      const accordionButton =
        currentPageItem?.closest(".sub-menu").previousElementSibling;
      if (
        accordionButton &&
        accordionButton.classList.contains("menu-accordion-button")
      ) {
        accordionButton.classList.add("active");
        currentPageItem?.closest(".sub-menu").classList.add("active");
      }
    } else {
      this.openFirstAccordion();
    }
  }

  /**
   * openFirstAccordion - Open the first accordion panel
   */
  private openFirstAccordion(): void {
    const firstAccordionButton = this.navigation?.querySelector(
      ".menu-accordion-button",
    );
    const firstSubMenu = this.navigation?.querySelector(".sub-menu");
    if (firstAccordionButton && firstSubMenu) {
      firstAccordionButton.classList.add("active");
      firstSubMenu.classList.add("active");
    }
  }
}
